// removed by extract-text-webpack-plugin
module.exports = {"switcher":"Switcher__switcher--2LNIO","spinner":"Switcher__spinner--1Awb2","load3":"Switcher__load3--3Kh8F","admin":"Switcher__admin--24A93","login":"Switcher__login--WY46z","notFound":"Switcher__notFound--VyF3e"};


//////////////////
// WEBPACK FOOTER
// ./src/css/Switcher.css
// module id = sUQT
// module chunks = 58